import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ErrorHandlerServiceService {
  errorMesssages = new Subject();

  constructor() {}
}
